<template>
  <div class="grid gap-4 p-6">
    <div class="flex flex-col space-y-1.5 text-center sm:text-left">
      <h2
        id="radix-_r_27_"
        class="text-lg font-semibold leading-none tracking-tight"
      >
        Apply Template to Digital Displays
      </h2>
      <p id="radix-_r_28_" class="text-sm text-muted-foreground">
        Select the ESL Tag and Product to apply the template
      </p>
    </div>
    <div class="grid gap-4 py-4">
      <el-form ref="ruleForm" :model="form" :rules="rules">
        <el-form-item label="Product" prop="product_code">
          <SmartSelect
            v-model="form.product_code"
            valueType="string"
            placeholder="Select Product"
            :load-method="getEslProducts"
            valueField="product_code"
            displayField="product_name"
            :pageSize="Number.MAX_SAFE_INTEGER"
            :pageFieldMap="{ page: 'f1', pageSize: 'f2' }"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="Template" prop="template_id">
          <SmartSelect
            v-model="form.template_id"
            valueType="string"
            placeholder="Select Template"
            :load-method="getEslTemplates"
            valueField="id"
            displayField="esltemplate_name"
            :pageSize="Number.MAX_SAFE_INTEGER"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="flex flex-row p-4 justify-end gap-4">
      <el-button @click="$emit('cancel')" icon="el-icon-close"
        >Cancel</el-button
      >
      <el-button
        :loading="isSubmitting"
        icon="el-icon-check"
        type="primary"
        @click="handleSubmit"
      >
        Apply Template
      </el-button>
    </div>
    <button
      type="button"
      @click="$emit('cancel')"
      class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
    >
      <i class="el-icon-close"></i>
      <span class="sr-only">Close</span>
    </button>
  </div>
</template>
<script lang="js">
import { triggerEslTasks, getEslProducts, getEslTemplates, bindEslTag } from "@/api";
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
export default {
  name: "ApplyTemplateToDisplays",
  components: {
    SmartSelect,
  },
  props: {
    esl_code: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        product_code: "",
        template_id: "",
      },
      isSubmitting: false,
      rules: {
        product_code: [
          { required: true, message: "Please select a Product", trigger: "change" },
        ],
        template_id: [
          { required: true, message: "Please select a Template", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    getEslProducts,
    getEslTemplates,
    async handleSubmit() {
      if (this.isSubmitting) return;
      await this.$refs.ruleForm.validate();
      try {
        this.isSubmitting = true;
        await bindEslTag({
          f1: this.esl_code,
          f2: this.form.product_code,
          f3: this.form.template_id,
        });
        await triggerEslTasks();
        this.$emit("confirm", this.form);
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
